import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import QueueingsPage from './QueueingsPage';
import './QueueingsPage.less';

export const prefix = 'bm-p-queueings';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: QueueingsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
